import { Chart } from "react-google-charts";
import { useProprietariosStatus } from "../hooks/useProprietariosStatus";

interface ProprietarioStatus {
  key: number;
  status: string;
}

export default function GraficoPizza() {
  // Busca os dados dos status
  const { proprietarioStatus } = useProprietariosStatus();

  // Converte os dados para o formato esperado
  const transformarDados = (data: any[]): ProprietarioStatus[] => {
    return data.map((item, index) => ({
      key: index + 1, // Gera um identificador único baseado no índice
      status: item.status, // Assume que os dados possuem a propriedade "status"
    }));
  };

  const dadosTransformados = transformarDados(proprietarioStatus);

  // Agrupa os dados por status
  const agruparPorStatus = (data: ProprietarioStatus[]): [string, number][] => {
    const contagem: Record<string, number> = {};
    data.forEach(({ status }) => {
      contagem[status] = (contagem[status] || 0) + 1; // Incrementa a contagem do status
    });
    return Object.entries(contagem); // Transforma o objeto em array de pares [status, quantidade]
  };

  // Dados agrupados no formato esperado
  const dadosAgrupados: [string, number][] =
    agruparPorStatus(dadosTransformados);

  // Formato do gráfico
  const data: (string | number)[][] = [
    ["Status", "Quantidade"],
    ...dadosAgrupados,
  ];

  // Opções do gráfico
  const options = {
    title: "Status dos Proprietários",
    pieHole: 0.4, // Torna o gráfico um donut
    is3D: false,
    colors: [
      "#003644",
      "#00688B",
      "#0099CC",
      "#00BFFF",
      "#00FFFF",
      "#A1CAF1",
      "#89CFF0",
    ], // Cores personalizadas
    legend: {
      position: "bottom",
    },
  };

  return (
    <div>
      <Chart
        chartType="PieChart"
        width="100%"
        height="400px"
        data={data}
        options={options}
      />
    </div>
  );
}
